/* @flow */

import truncate from 'lodash/truncate';

const truncateComTitle = (title: string) => `<span title="${title}">${truncate(title)}</span>`;

export default truncateComTitle;
